
<style lang="scss">
  @import "../utils.scss";
  $base-color:#79BD50;
  .wrapper {
    height: 100%;
    height: 100vh;
  }
  .banner {
    width: 100%;
    height: px2rem(150px);
    background: url("../assets/banner.jpeg") no-repeat;
    background-size: cover;
  }

  .shop {
    background: #f8f8f8;
    font-size: 28px;
    padding-bottom: px2rem(53px);
    height: 100%;
    max-height: calc(100% - 1.28rem);
    max-height: calc(100vh - 1.28rem);
    overflow: scroll;
    -webkit-overflow-scrolling:touch;
  }

  .count-btn {
    width: px2rem(18px);
    height: px2rem(18px);
    border-radius: px2rem(18px);
    display: inline-block;
    text-align: center;
    @include font-dpr(20px);
    margin-bottom: px2rem(2px);
  }

  .minus-btn {
    float: right;
    width: px2rem(18px);
    height: px2rem(18px);
    border: px2rem(1px) solid $base-color;
    color: $base-color;
    line-height: px2rem(18px);
  }

  .add-btn {
    float: right;
    width: px2rem(18px);
    height: px2rem(18px);
    background:  $base-color;
    color: white;
    line-height: px2rem(18px);

  }
  .count-num {
    float: right;
    width: px2rem(40px);
    text-align: center;
  }
  .for-customers {
    padding: px2rem(5px);
    color: #333;
    @include font-dpr(18px);
  }

  .content-container {
    display: inline-block;
    width: 100%;
    background: #f8f8f8;
    &.fixed {
      position: fixed;
      top: 0;
      height: 100%;
      height: 100vh;
      .goods-list {
        height: 100%;
        overflow-y: scroll; /* has to be scroll, not auto */
        -webkit-overflow-scrolling: touch;
      }
    }
  }
  .categories {
    @include font-dpr(13px);
    background: #f8f8f8;
    display: inline-block;
    width: 20%;
    min-height: px2rem(150px);
    ul {
      li {
        padding: px2rem(2px) px2rem(10px);
        height: 40px;
        line-height: 40px;
        color: #666;
        &.selected{
          background: white;
        }
      }
    }
    &.fixed {
      position: fixed;
      top: 0;
    }
  }

  ul.goods-list {
    background: white;
    float: right;
    display: inline-block;
    width: 80%;
    overflow: hidden;
    padding-top: 1px;
    .category-name {
      width: 100%;
      @include font-dpr(12px);
    }
    li {
      font-size: 0;
      padding-left: px2rem(10px);
      padding-top: px2rem(10px);
      padding-bottom: px2rem(10px);
      /*width: px2rem(180px);*/
      display: inline-block;
      float: left;
      overflow: hidden;
      &:last-child{
        margin-bottom: px2rem(48px);
      }
    }
  }

  .goods-container {
    img {
      width: 30%;
      height: px2rem(80px);
      vertical-align: bottom;
    }
    height: 100%;
    .goods-info {
      width: 70%;
      height: 100%;
      height: px2rem(80px);
      display: inline-flex;
      flex-direction: column;
      justify-content: space-around;
      background: white;
      @include font-dpr(16px);
      color: #333;
      font-weight: bold;
      box-sizing: border-box;
      padding: px2rem(0px)  px2rem(14px);
    }
    .goods-desc {
      display: inline-block;
      @include font-dpr(13px);
      color: #999;
    }
    .goods-price {
      color: $base-color;
      @include font-dpr(15px);
    }
    .origin-price {
      color: #999;
      text-decoration: line-through;
      @include font-dpr(13px);
    }
    .price-unit {
      color: $base-color;
      @include font-dpr(12px);
    }
  }

  .goods-count {
    display: inline-flex;
    align-items: center;
    height: px2rem(28px);
    flex: 1;
    i {
      background: url("../assets/icon_cart@2x.png");
      display: inline-block;
      height: px2rem(28px);
      width: px2rem(28px);
      background-size: contain;
      margin-left: px2rem(20px);
    }
    .value {
      position: absolute;
      display: inline-block;
      height: px2rem(18px);
      /*width: px2rem(18px);*/
      padding: 0 2px;
      line-height: px2rem(18px);
      text-align: center;
      @include font-dpr(12px);
      border-radius: px2rem(18px);
      background: $base-color;
      color: white;
      top: px2rem(4px);
      left: px2rem(38px);
      border: px2rem(2px) solid white;
    }

    .price {
        @include font-dpr(24px);
        margin-left: px2rem(24px);
        color: $base-color;
        vertical-align: top;
        margin-right: px2rem(6px);
    }

    .min-fee {
      @include font-dpr(12px);
      color: #999999;
      line-height: px2rem(14px);
    }
  }
  .specs {
    position: fixed;
    bottom: px2rem(0);
    background: #f7f7f7;
    width: 100%;
    z-index: 100;
    margin-top: px2rem(16px);
    .title {
          @include font-dpr(16px);
          color: #333;
          line-height: px2rem(40px);
          margin-left: px2rem(20px);
    }
    .item-container {
      margin-left: px2rem(20px);
      .item {
        padding: px2rem(4px) px2rem(15px);
        display: inline-block;
        color: #333;
        border: 0;
        background: #e1e1e1;
        margin-right: px2rem(10px);
        margin-bottom: px2rem(10px);
        @include font-dpr(13px);
      }
      .item-title {
        @include font-dpr(13px);
        margin: px2rem(10px) 0;
      }
      .selected {
        color: #79BD50;
        background: rgb(195, 245, 166);
      }
    }
    .button-row {
      padding: 0 px2rem(20px);
      overflow: hidden;
      margin: px2rem(0px) 0 px2rem(30px) 0;
      display: flex;
      justify-content: flex-end;
      .button-container {
        float: right;
        display: block;
        .count-num {
          @include font-dpr(16px);
        }
      }
    }
    
  }
  .cart {
    position: fixed;
    bottom: px2rem(48px);
    background: #f7f7f7;
    width: 100%;
    z-index: 99;
    .header {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        height: px2rem(40px);
        background: white;
        box-shadow: 0 px2rem(-2px) px2rem(4px) 0 rgba(0,0,0,0.10);
        .title {
          @include font-dpr(16px);
          color: #333;
          line-height: px2rem(40px);
          margin-left: px2rem(20px);
          &:before {
              content: ' ';
              display: inline-block;
              height: px2rem(16px);
              width: px2rem(3px);
              margin-right: px2rem(6px);
              background: $base-color;
              margin-bottom: -2px;
           }
        }
        .clear-goods {
          float: right;
          line-height: px2rem(40px);
          margin-right: px2rem(20px);
          i {
             display: inline-block;
            height: px2rem(20px);
             width: px2rem(20px);
            background: url("../assets/trash.png");
            background-size: contain;
            vertical-align: text-bottom;
            margin-right: px2rem(6px);
          }
          @include font-dpr(14px);


        }
    }
    .cart-item {
        @include font-dpr(14px);
        color: #666;
        margin-top: px2rem(16px);
        padding: 0 px2rem(20px);
        &:last-child {
            margin-bottom: px2rem(16px);
         }

         .quantity {
            float: right;
           margin-right: px2rem(40px);
         }

         .price {
            float: right;
            width: px2rem(80px);
           text-align: right;
         }


    }
  }
  .masker {
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      position: absolute;
      background: black;
      opacity: .6;
  }
  .bottom-options{
    position: fixed;
    bottom:0;
    z-index: 99;
    height: px2rem(48px);
    width: 100%;
    background: white;
    @include font-dpr(18px);
    box-shadow: 0 px2rem(-2px) px2rem(4px) 0 rgba(0,0,0,0.10);
    display: flex;
    align-items: center;
  }


  .go-order{
      float:right;
    @include font-dpr(18px);
      width: px2rem(134px);
      border:0;
      height: 100%;
      line-height:  px2rem(48px);
      background: $base-color;
      color: white;
    font-weight: bold;
    }
  button[disabled] {
    background: #c0c0c0;
  }

  .shadow {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 999;
    background: black;
      img {
        height: auto !important;
      }
  }

    .time-masker {
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      position: fixed;
      background: rgba(0,0,0,.6);
      z-index: 999;
        display: flex;
    align-items: center;
    justify-content: center;
      .open-time {
        color: white;
        text-align: center;
        @include font-dpr(16px);
      }
  }
</style>
<template>
  <div class="wrapper" ref='wrapper'>
    <div class="shop" @scroll="handleScroll" ref="shop">
    <div class="shadow" v-if="slides && slides.length" @click="goBack()">
        <slider :slides="slides" @on-img-tap="goBack()"></slider>
    </div>
    <div class='banner' ref="banner"></div>
    <div class="for-customers" v-if="customer.isAdmin">
      <span>服务用户：</span>
      <select :value="forCustomer" @change="forCustomersChange">
        <option value="">请选择</option>
        <option v-for="forCustomer in forCustomers" :key="forCustomer._id" :value="forCustomer._id">{{forCustomer.name}}</option>
      </select>
    </div>
    <div class="content-container" ref="contentContainer">
      <div class="categories" :class="{'fixed': fixed}">
        <ul>
          <li v-for="(category, index) in categories" :key="category._id" 
            :class="{'selected': index == currentCategoryIndex}"
            @click="changeCategory(index, category)">{{ category.name }}</li>
        </ul>
      </div>
      <ul class="goods-list" @scroll="goodsScroll" ref="goodsList">
      <template v-for="category in categories">
        <li class="category-name" :ref="category._id || 'recenty_buy_category'">{{category.name}}</li>
        <li v-for='g in category.products'>
          <div class='goods-container'>
              <img :src="g.images[0]" @click="showSlider(g)">
            <div class="goods-info">
              <p>
                <span class='goods-name'>{{g.name}}</span>
              </p>
              <p>
                <span class='goods-desc'>{{g.desc}}</span>
              </p>
              <p>
                <span class='goods-price'>¥{{Number(g.customerPrice || g.price).toFixed(1)}}</span><span class="price-unit">元/{{g.unit || '斤'}}</span>
                <!-- <span class='origin-price' v-if="g.customerPrice < g.price">¥{{g.price}}</span> -->
                <span class='count-btn add-btn'  @click='addCartNumber(g)'>+</span>
                <input type='number' v-model='productCartNum[g._id]' @change="alterNum(g,$event)" :style="{visibility: productCartNum[g._id] ? 'visible' : 'hidden'}" class="count-num">
                <span class='count-btn minus-btn' @click='removeCartNumber(g)' :style="{visibility: productCartNum[g._id] ? 'visible' : 'hidden'}">-</span>
              </p>
            </div>
          </div>
        </li>
      </template>
      
    </ul>
    </div>
    
    <div class="cart" v-show='cartShow'>
      <div class="header"><span class="title">购物车</span> <span class="clear-goods" @click="clearCart()"><i></i>清空</span></div>

      <ul>
        <li v-for='g in cartGoods' :key="g.id">
          <p class="cart-item">
            <span>{{g.name}}{{g.spec ? ` [${g.spec}]`:""}}</span>
            <span class="price">¥{{Math.round(g.quantity * g.price*100)/100}}</span>
            <span style="float:right" v-if="g.unit2">(约{{Number(g.quantity).toFixed(2)}}{{g.unit|| '斤'}})</span>
            <span  style="float:right">&nbsp;&nbsp;&nbsp;&nbsp;{{parseInt(g.quantity/(g.unit2 ? g.priceTransfer : 1))}}{{g.unit2 || g.unit || '斤'}}</span>
            <!--<span class='count-btn' @click='removeFromCart(g)'>-</span>-->
            <!--<span class='count-btn' @click='addToCart(g)'>+</span>-->
          </p>
        </li>
      </ul>
    </div>
    <div class="masker" v-show='cartShow' @click="cartShow=false;"></div>

    <div class="masker" v-show='specsShow' @click="specsShow=false;"></div>

    <div class="time-masker" v-show='false'>
        <div class="open-time">
          <p>本店打烊啦！</p>
          <p>营业时间6：00-23：30</p>
          <p>欢迎明日光临!</p>
        </div>
    </div>
  </div>
  <div class="specs" v-show='specsShow'>
      <p class="title">{{currentProduct.name}}</p>
      <ul class="item-container" v-if="currentProduct.unit2 && currentProduct.priceTransfer">
        <li class="item-title">单位</li>
        <li class="item" :class="{'selected': currentProduct.unit2 !== currentUnit }" @click="selectUnit(currentProduct.unit)">
          {{currentProduct.unit}}
        </li>
        <li class="item" :class="{'selected': currentProduct.unit2 === currentUnit }" @click="selectUnit(currentProduct.unit2)">
          {{currentProduct.unit2}}
        </li>
      </ul>
      <ul class="item-container" v-if="currentProduct.specs && currentProduct.specs.length > 1">
        <li class="item-title">规格</li>
        <li class="item" v-for="spec in currentProduct.specs" :key="spec" :class="{'selected': spec === currentSpec }" @click="selectSpec(spec)">
          {{spec}}
        </li>
      </ul>
      <div class="button-row">
        <div class="button-container">
          <span class='count-btn add-btn'  @click='addSpecToCart(currentProduct)'>+</span>
          <input type='number' v-model='productCartNum[currentProduct._id]' @change="alterNum(currentProduct,$event)" :style="{visibility: productCartNum[currentProduct._id] ? 'visible' : 'hidden'}" class="count-num">
          <span class='count-btn minus-btn' @click='removeSpecFromCart(currentProduct)' :style="{visibility: productCartNum[currentProduct._id] ? 'visible' : 'hidden'}">-</span>
        </div>
      </div>
  </div>
  <div class="bottom-options">
      <p class="goods-count"  @click='toggleCart()'><i></i><span class="value">{{productCartTotalNum}}</span><span class="price">¥{{totalPrice}}</span>
        <span class="min-fee" v-show="totalPrice < 0.001">起送金额{{minMoney}}元</span>
      </p>
      <button class="go-order" @click='goCheckout()' :disabled="totalPrice < 0.001">
        立即下单
      </button>
    </div>
  </div>

</template>
<script>
import { host } from '../config'
import { mapGetters, mapActions } from 'vuex'
require('pinch-slider/dist/pinch-slider.css');
import Vue from 'vue';
import _ from 'lodash'
// in ES6 modules
import { PinchSlider, AlloyFinger, AlloyFingerVue } from 'pinch-slider';
import { setTimeout } from 'timers';
import { debug } from 'util';
import utilMixin from './mixins/utils'

Vue.use( AlloyFingerVue, { AlloyFinger: AlloyFinger }); // use AlloyFinger's plugin
Vue.component('slider', PinchSlider);

export default {
  name: 'shop',

  mixins: [utilMixin()],

  computed: {
    ...mapGetters({
      goods: 'allProducts',
      categories: 'categories',
      cartGoods: 'cartProducts',
      productCartNum: 'productCartNum',
      checkoutStatus: 'checkoutStatus',
      totalPrice: 'totalPrice',
      productCartTotalNum: 'productCartTotalNum',
      forCustomer: 'forCustomer',
    }),

    openTime() {
      let d = new Date();
      let h = d.getHours();
      return  h > 5 && h < 23 || (h == 23 && d.getMinutes() < 30);
    },
  },
  // watch: {
  //   forCustomer(val) {
  //     this.$store.dispatch('getAllProducts', val);
  //   }
  // },
  data() {
    return {
      forCustomers: [],
      minMoney: 0,
      cartShow: false,
      specsShow: false,
      currentSpec: '',
      currentUnit: '',
      msg: 'Welcome to Your Vue.js App',
      slides:[],
      currentCategoryIndex: 0,
      fixed: false,
      currentProduct: {},
      customer: {},
      fixedScroll: 0,
    };
  },
  methods: {
    ...mapActions([
      'addToCart',
      'removeFromCart',
      'alterNum',
      'alertSpec',
      'alertUnit',
    ]),
    forCustomersChange(e) {
      this.$store.dispatch('setForCustomer', e.currentTarget.value)
      this.$store.dispatch('getAllProducts')
    },
    removeCartNumber(g) {
      if ((g.specs && g.specs.length > 1) || (g.unit2 && g.priceTransfer)) {
        this.specsShow = true
        this.currentProduct = g
        let cartGood = this.cartGoods.filter(e => e._id === g._id)
        this.currentSpec = cartGood[0] && cartGood[0].spec
        this.currentUnit = (cartGood[0] && cartGood[0].unit2) || g.unit
      } else {
        this.removeFromCart(g)
      }
    },
    addCartNumber(g) {
      if ((g.specs && g.specs.length > 1) || (g.unit2 && g.priceTransfer)) {
        this.specsShow = true
        this.currentProduct = g
        let cartGood = this.cartGoods.filter(e => e._id === g._id)
        this.currentSpec = cartGood[0] && cartGood[0].spec
        this.currentUnit = (cartGood[0] && cartGood[0].unit2) || g.unit
      } else {
        this.addToCart({ ...g, unit2: this.currentUnit === g.unit ? undefined : g.unit2 })
      }
    },
    addSpecToCart(g) {
      if (!this.currentSpec && this.currentProduct.specs && this.currentProduct.specs.length > 1 ) {
        alert('请选择规格')
        return
      }
      this.addToCart({ ...g, unit2: this.currentUnit === g.unit ? undefined : g.unit2 })
    },
    removeSpecFromCart(g) {
      if (!this.currentSpec && this.currentProduct.specs && this.currentProduct.specs.length > 1) {
        alert('请选择规格')
        return
      }
      this.removeFromCart(g)
    },
    selectSpec(spec) {
      this.currentSpec = spec
      this.currentProduct.spec = spec
      this.alertSpec(this.currentProduct, spec)
    },
    selectUnit(unit) {
      this.currentUnit = unit
      let unit2 = unit === this.currentProduct.unit ? undefined : this.currentProduct.unit2
      
      this.alertUnit({ ...this.currentProduct, unit2 })
    },
    checkout (products) {
      this.$store.dispatch('checkout', products)
    },

    showSlider(g) {
        let array = [];
        g.images.map((e)=>{
            array.push({src: e});
        });
        this.slides = array;
        window.history.replaceState({imageView:true},'', '');
        window.history.pushState({},'', '#')
    },

    goBack() {
        window.history.go(-1);
    },

    clearSlider() {
        this.slides=[];
    },

    goCheckout() {
      if (this.isLogin) {
        this.$router.push('/checkout/');
      } else {
        this.$router.push('/login/');
      }
    },

    clearCart() {
        this.$store.dispatch('clearCart');
        this.cartShow = false;
    },

    toggleCart() {
        if(this.cartShow){
            this.cartShow = false;
        }else if(this.cartGoods.length){
            this.cartShow = true;
        }
    },
    changeCategory(index, category) {
      this.currentCategoryIndex = index
      this.$refs[this.categories[index]._id || 'recenty_buy_category'][0].scrollIntoView(true, {
          behavior: "smooth",
          block:    "start",
          inline: "nearest"
      })
    },
    handleScroll() {
      let vm = this
      _.throttle(() => {
        if(vm.$refs.shop.scrollTop >= this.fixedScroll) {
          vm.fixed = true
        } else {
          vm.fixed = false
        }
      }, 50, {trailing: true})()

    },
    goodsScroll() {
      // let vm = this
      // console.log('scroll e')
      // _.throttle(() => {
      //   if(this.$refs.goodsList.scrollTop == 0) {
      //     this.fixed = false
      //     vm.$nextTick(() => {
      //       vm.$refs['shop'].scrollTop = vm.$refs['banner'].clientHeight
      //     })
      //   }
      // }, 50, {trailing: true})()
    }

  },

 

  created() {
    process.env.NODE_ENV === 'production' && fetch(host + '/api/redirect'+ (this.$route.query.code ? '?code='+ this.$route.query.code :''),{
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'mode': 'no-cors',
            },
            credentials: 'include',
            method: "get",
        }).then((response) => {
                    return response.json();
                  }).then((data)=>{
                    if(data.data.redirect) {
                      window.location.href = data.data.redirect
                    }
        });
    this.$store.dispatch('getAllProducts');
    
    this.getLogin().then(isLogin => {
      if (isLogin) {
        this.$http.get(host + '/api/customer/info', {withCredentials: true}).then(res => {
            this.customer = res.data.data
            if (this.customer.isAdmin) {
              this.$http.get(host + '/api/support/customer/list', {withCredentials: true, params: { phone: this.customer.phone }}).then(res => {
                this.forCustomers = res.data.data
              })
            }
        })
        .catch(e => {
          // if (e.response.data.message == '无登录信息') {
          //   this.$router.push('/login')
          // } else {
            console.log(e.response.data.message)
          // }
        })
      } else {
        this.$router.push('/login/');
      }
    })
    
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
      let self = this;
      
      window.onpopstate= function (event) {
          console.log(event);
          console.log(event.state);
        if(event.state && event.state.imageView){
            self.clearSlider();
        }
      }
      this.fixedScroll = this.$refs.contentContainer.offsetTop
      
},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// Shop.vue?4a15240a